'use client';

import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import styles from './GridPresentation.module.scss';
import { Button, Card, Container, Grid, Group, Text } from '@mantine/core';
import { useAOS } from '@/src/lib/hooks/useAOS';

export const GridPresentation = ({
  services,
  contactInfo,
}: {
  services: any[];
  contactInfo: any;
}) => {
  useAOS();

  return (
    <section className={styles.section}>
      <Container my="md">
        <Grid gutter="lg">
          <Grid.Col span={{ base: 12, sm: 6, lg: 7 }}>
            {/* Services Section */}
            {services.map((service, index) => (
              <div className={styles.cardWrapper} key={index} data-aos="zoom-in">
                <Link href={service.link} className={styles.link}>
                  <Card p="lg" className={styles.card}>
                    <Group>
                      <Image src={service.icon} alt={service.title} width="50" height="50" />
                      <h2>{service.title}</h2>
                    </Group>
                    <Text size="sm">
                      {service.description}
                    </Text>
                  </Card>
                </Link>
              </div>
            ))}
          </Grid.Col>

          {/* Contact Section */}
          <Grid.Col span={{ base: 12, sm: 6, lg: 5 }}>
            <Card p="lg" className={styles.card} data-aos="zoom-in">
              <Group>
                <Image src={contactInfo.icon} alt={contactInfo.title} width="50" height="50" />
                <h2>{contactInfo.title}</h2>
              </Group>
              <Text size="sm" mb="md">
                {contactInfo.address}
              </Text>
              <Text size="sm" mb="md">
                {contactInfo.phone}
              </Text>
              <Text size="sm" mb="lg">
                {contactInfo.email}
              </Text>
              <iframe
                title="Map"
                style={{ width: '100%', height: 280, border: 0, borderRadius: 8 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps?q=${encodeURIComponent(contactInfo.address)}&output=embed`}
              />
              <Group align="center" mt="lg">
                <Button
                  className={styles.button}
                  radius="md"
                  component={Link}
                  href={contactInfo.href}
                >
                  {contactInfo.button}
                </Button>
              </Group>
            </Card>
          </Grid.Col>
        </Grid>
      </Container>
    </section>
  );
};
